/* (ignored) */


//////////////////
// WEBPACK FOOTER
// got (ignored)
// module id = 0
// module chunks = 1 2